/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Skillgroupcount2Inputs */

const en_entity_skillgroupcount2 = /** @type {(inputs: Entity_Skillgroupcount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Group Count`)
};

const de_entity_skillgroupcount2 = /** @type {(inputs: Entity_Skillgroupcount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Skillgruppen`)
};

/**
* | output |
* | --- |
* | "Skill Group Count" |
*
* @param {Entity_Skillgroupcount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_skillgroupcount2 = /** @type {((inputs?: Entity_Skillgroupcount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Skillgroupcount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_skillgroupcount2(inputs)
	return de_entity_skillgroupcount2(inputs)
});
export { entity_skillgroupcount2 as "entity_skillGroupCount" }